import React from "react";
import ModalWrap from "./ModalWrap";
import { Typography } from "@mui/material";
import "./removesenior.scss";
import { removeSenior } from "../../services/websiteApi";
import { useDispatch } from "react-redux";
import { setAPILoader } from "../../state/actions/globalAction";
import { pageLocale, getCurrentLocale } from "../../utlis/locale";
import { formatName } from "../../utlis/commonFunction";

const RemoveSenior = ({
  removeSeniorModal,
  setRemoveSeniorModal,
  setRemovePopup,
  userInfo,
}) => {
  const dispatch = useDispatch();
  const { are_you, no, yes_remove } = pageLocale("popup");
  const removeSeniorHandler = () => {
    dispatch(setAPILoader(true)),
      removeSenior(userInfo?.id)
        .then(() => {
          dispatch(setAPILoader(false));
          sessionStorage.removeItem("userList");
          setRemovePopup(true);
          setRemoveSeniorModal(false);
        })
        .catch(() => {
          dispatch(setAPILoader(false));
          setRemoveSeniorModal(false);
        });
  };
  const displayName = formatName(userInfo, getCurrentLocale());

  return (
    <ModalWrap
      className="remove-senior-modal-wrapper"
      open={removeSeniorModal}
      onClose={() => setRemoveSeniorModal(false)}
    >
      <div className="remove-senior-info-block">
        <Typography className="confirm-text">
          {are_you} {displayName}
        </Typography>
        <div className="btn-block">
          <button
            className="cancel-btn"
            onClick={() => setRemoveSeniorModal(false)}
          >
            {no}
          </button>
          <button className="confirm-btn" onClick={removeSeniorHandler}>
            {yes_remove}
          </button>
        </div>
      </div>
    </ModalWrap>
  );
};

export default RemoveSenior;
